import React from 'react';
import { Switch, useLocation } from 'react-router-dom';
import { Header } from './components/Header';

import { Container } from './styles';

export const Mobile: React.FC = ({ children }) => {
  const location = useLocation();

  return (
    <Container>
      <Header />
      <div>
        <Switch location={location}>{children}</Switch>
      </div>
    </Container>
  );
};
